import styled, { css } from "styled-components";

const CSSRequired = css`
    &::after {
        color: #c32;
        content: "*";
    }
`;

interface IFieldLabelProps {
    required?: boolean
}

export default styled.span<IFieldLabelProps>`
    color: #334;
    font-size: 1em;
    font-weight: 500;

    ${ ({ required }) => required && CSSRequired }
`;
